import { render, staticRenderFns } from "./dept-page.vue?vue&type=template&id=3101f2b7&scoped=true"
import script from "./dept-page.vue?vue&type=script&lang=js"
export * from "./dept-page.vue?vue&type=script&lang=js"
import style0 from "./dept-page.vue?vue&type=style&index=0&id=3101f2b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3101f2b7",
  null
  
)

export default component.exports